import { EntityRepository, Repository } from "typeorm";
import { TransferItems } from "../entities/transfer-items.entity";

@EntityRepository(TransferItems)
export class TransferItemsRepository extends Repository<TransferItems>{

}